export default __webpack_public_path__ + "static/media/viber_image_2022-06-02_10-09-50-183.d94098a6.jpg";